import { addToCart } from '~/js/lib/cart'; // eslint-disable-line
import variantSelect from './variant-select';

export default (node) => {
  const quantity = node.querySelector('[data-quantity]');
  const decreaseQuantityButton = node.querySelector('[data-decrease-quantity]');
  const increaseQuantityButton = node.querySelector('[data-increase-quantity]');
  const cartTemplate = node.getAttribute('data-cart-template');
  const buttonAddToCart = node.querySelector('[data-button-add-to-cart]');
  const buttonNotifyMe = node.querySelector('[data-button-notify-me]');
  const loadingText = node.getAttribute('data-loading-text');
  const shopCurrency = node.dataset.shopCurrency;
  let variantId = node.dataset.variantId;
  const variantSelectNode = node.querySelector('[data-variant-select]');
  const isMtoProduct = node.dataset.isMtoProduct === 'true';
  const doNotOpenDrawer = node.dataset.doNotOpenDrawer ? node.dataset.doNotOpenDrawer === 'true' : false;

  const handleVariantChange = (newVariant, newVariantId) => {
    variantId = newVariant.id;

    // Update component data attributes
    node.dataset.variantId = newVariantId || newVariant.id;

    const isAvailable = newVariant.available === true;
    const outOfStockStrategy = newVariant.out_of_stock_strategy || '';

    // Determine which button should be shown based on availability and strategy
    const shouldShowNotifyMe =
      !isAvailable && outOfStockStrategy === 'notifications';
    const shouldShowSoldOut = outOfStockStrategy === 'sold_out';
    const isMto = outOfStockStrategy === 'made_to_order';

    // Update component state
    node.dataset.isMtoProduct = isMto;

    // Show/hide buttons based on state
    if (buttonNotifyMe) {
      if (shouldShowNotifyMe) {
        buttonNotifyMe.classList.remove('hidden');
        buttonNotifyMe.dataset.variantId = variantId;
      } else {
        buttonNotifyMe.classList.add('hidden');
      }
    }

    const soldOutButton = node.querySelector('[data-button-sold-out]');
    if (soldOutButton) {
      if (shouldShowSoldOut) {
        soldOutButton.classList.remove('hidden');
      } else {
        soldOutButton.classList.add('hidden');
      }
    }

    // Update Add to Cart button
    if (buttonAddToCart) {
      const shouldShowAddToCart =
        !shouldShowNotifyMe && !shouldShowSoldOut && (isAvailable || isMto);

      if (shouldShowAddToCart) {
        buttonAddToCart.classList.remove('hidden');

        // Update button text based on product type
        const prefix = buttonAddToCart.dataset.prefix || '';
        let buttonText;

        if (isMto) {
          buttonText = buttonAddToCart.dataset.mtoText || 'Order';
        } else {
          buttonText = buttonAddToCart.dataset.addText || 'Add to Cart';
        }

        // Apply prefix if exists
        if (prefix && buttonText) {
          buttonText = `${prefix} ${buttonText}`;
        }

        buttonAddToCart.textContent = buttonText;
        buttonAddToCart.disabled = false;
      } else {
        buttonAddToCart.classList.add('hidden');
      }
    }
  };

  const handleNotifyMeClick = (e) => {
    e.preventDefault();
    if (variantId) {
      document.dispatchEvent(
        new CustomEvent('notify:open', {
          detail: { variantId: variantId },
        })
      );
    } else {
      console.error('No variant ID available for notify subscription');
    }
  };

  const handleAddToCartClick = async (e) => {
    e.preventDefault();

    const productTitle = node.dataset.productTitle;
    const productPrice = node.dataset.productPrice;

    // We need to query this to have the correct status of the cart
    const cartProductStatus = document.getElementById('cart-product-status');
    if (!cartProductStatus) {
      console.error(
        'Element with ID "cart-product-status" not found in the DOM.'
      );
      return;
    }

    const cartHasMto = cartProductStatus.dataset.hasMto === 'true';
    const cartHasRegularItems =
      cartProductStatus.dataset.isEmpty === 'false' &&
      !cartHasMto;

    const showError =
      // If the cart has regular items and the product is MTO, we need to show an error
      (cartHasRegularItems && isMtoProduct) ||
      // If the cart has MTO and the product is not MTO, we need to show an error
      (cartHasMto && !isMtoProduct);

    if (showError) {
      // emit event to show stock error modal
      document.dispatchEvent(
        new CustomEvent('stock:error', {
          detail: {
            variant: isMtoProduct || cartHasMto ? 'mto' : 'regular',
          },
        })
      );
      return;
    }

    const itemToAdd = [
      {
        id: Number(variantId),
        quantity: quantity ? parseInt(quantity.value) : 1,
      },
    ];

    let currentButtonText = buttonAddToCart.textContent;
    buttonAddToCart.textContent = loadingText;
    buttonAddToCart.disabled = true;
    const result = await addToCart(itemToAdd);
    buttonAddToCart.textContent = currentButtonText;
    buttonAddToCart.disabled = false;

    if (result) {
      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: shopCurrency,
          add: {
            products: [
              {
                name: productTitle,
                id: variantId,
                price: productPrice / 100,
                quantity: quantity ? parseInt(quantity.value) : 1,
              },
            ],
          },
        },
      });
    }

    // Reset quantity input back to 1 (after dataLayer push to preserve original value)
    if (quantity) quantity.value = 1;

    // Open cart drawer — also on partial add so user sees what was added
    if (!doNotOpenDrawer) {
      document.dispatchEvent(new CustomEvent('cart:open'));
    }
  };

  const handleQuantityChange = (change) => {
    const currentValue = parseInt(quantity.value);
    if (change === 'increase') {
      return (quantity.value = currentValue + 1);
    }
    quantity.value = currentValue - 1 <= 0 ? 1 : currentValue - 1;
  };

  // Initialize event listeners
  if (decreaseQuantityButton) {
    decreaseQuantityButton.addEventListener('click', () =>
      handleQuantityChange('decrease')
    );
  }

  if (increaseQuantityButton) {
    increaseQuantityButton.addEventListener('click', () =>
      handleQuantityChange('increase')
    );
  }

  if (buttonAddToCart) {
    buttonAddToCart.addEventListener('click', handleAddToCartClick);
  }

  if (buttonNotifyMe) {
    buttonNotifyMe.addEventListener('click', handleNotifyMeClick);
  }

  if (variantSelectNode) {
    variantSelect(variantSelectNode, handleVariantChange);
  }
};
